/* Developed by MontenegroSoft - www.montenegrosoft.com */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ms-banner-carousel').forEach((root) => {
    const autoplaySeconds = parseInt(root.dataset.autoplay) || 0;
    const track = root.querySelector('.ms-banner-carousel__track');
    const slides = root.querySelectorAll('.ms-banner-carousel__slide');
    const btnPrev = root.querySelector('.ms-banner-carousel__arrow-left');
    const btnNext = root.querySelector('.ms-banner-carousel__arrow-right');
    const dotsWrap = root.querySelector('.ms-banner-carousel__dots');
    if (!track || slides.length === 0) return;

    let index = 0;
    let dots = [];
    let timerId = null;

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      if (slides.length <= 1) {
        dotsWrap.style.display = 'none';
        btnPrev?.classList.add('hidden');
        btnNext?.classList.add('hidden');
        return;
      }
      dotsWrap.style.display = 'flex';
      btnPrev?.classList.remove('hidden');
      btnNext?.classList.remove('hidden');
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ms-banner-carousel__dot';
        dot.addEventListener('click', () => {
          index = i;
          update();
          start();
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function width() {
      return root.clientWidth;
    }

    function adjustCarouselHeight() {
      const activeSlide = slides[index];
      if (!activeSlide) return;
      const img =
        window.innerWidth < 750
          ? activeSlide.querySelector('.ms-banner-carousel__img-mobile')
          : activeSlide.querySelector('.ms-banner-carousel__img-desktop');
      if (!img) return;
      const setHeight = () => {
        if (img.naturalWidth > 0)
          root.style.height = Math.round((img.naturalHeight * root.clientWidth) / img.naturalWidth) + 'px';
      };
      img.complete ? setHeight() : img.addEventListener('load', setHeight);
    }

    function update() {
      track.style.transition = 'transform .5s ease';
      track.style.transform = `translateX(${-index * width()}px)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      adjustCarouselHeight();
    }

    function next() {
      index = (index + 1) % slides.length;
      update();
    }

    function prev() {
      index = (index - 1 + slides.length) % slides.length;
      update();
    }

    const interval = autoplaySeconds * 1000;
    function start() {
      clearInterval(timerId);
      if (slides.length > 1 && interval > 0) timerId = setInterval(next, interval);
    }

    btnPrev?.addEventListener('click', () => {
      prev();
      start();
    });
    btnNext?.addEventListener('click', () => {
      next();
      start();
    });

    let isDown = false,
      startX = 0,
      deltaX = 0,
      shouldCancelClick = false;
    const dragThresholdSlide = () => width() * 0.18;
    const dragThresholdClick = 8;

    function onPointerDown(e) {
      isDown = true;
      deltaX = 0;
      startX = e.clientX || e.touches?.[0]?.clientX || 0;
      track.style.transition = 'none';
      clearInterval(timerId);
    }

    function onPointerMove(e) {
      if (!isDown) return;
      const x = e.clientX || e.touches?.[0]?.clientX || 0;
      deltaX = x - startX;
      track.style.transform = `translateX(${-index * width() + deltaX}px)`;
    }

    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      shouldCancelClick = Math.abs(deltaX) > dragThresholdClick;
      if (Math.abs(deltaX) > dragThresholdSlide()) deltaX < 0 ? next() : prev();
      else update();
      start();
      deltaX = 0;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    track.addEventListener('touchmove', onPointerMove, { passive: true });
    track.addEventListener('touchend', onPointerUp);

    root.addEventListener(
      'click',
      (e) => {
        if (shouldCancelClick) {
          e.preventDefault();
          e.stopPropagation();
          shouldCancelClick = false;
        }
      },
      true
    );

    root.querySelectorAll('a, img').forEach((el) => {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });

    window.addEventListener('resize', update);

    buildDots();
    update();
    start();
  });
});
